import moment from "moment"
import { JourneyDayItem, QuotationVersionItemModel } from "../../models/axiosModel"

export interface QuotationPreviewHotelRow {
  city: string
  hotel_name: string
  room: string
  checkIn: string
  checkOut: string
}

const formatDateDash = (value?: string | Date) =>
  value ? moment(value).format("DD-MM-YYYY") : "-"

const hasSameHotelIdentity = (
  left: QuotationPreviewHotelRow,
  right: QuotationPreviewHotelRow,
) =>
  left.city === right.city &&
  left.hotel_name === right.hotel_name &&
  left.room === right.room

export const getQuotationPreviewHotelRows = (
  days: JourneyDayItem[],
): QuotationPreviewHotelRow[] => {
  const rows: QuotationPreviewHotelRow[] = []
  let activeRow: QuotationPreviewHotelRow | null = null

  days.forEach((day, index) => {
    if (!day.hotel) {
      activeRow = null
      return
    }

    const row: QuotationPreviewHotelRow = {
      city: day.city_name || "-",
      hotel_name: day.hotel.hotel_name || "-",
      room: day.hotel.hotel_room_type_name || "-",
      checkIn: formatDateDash(day.date),
      checkOut: formatDateDash(days[index + 1]?.date || day.date),
    }

    if (activeRow && hasSameHotelIdentity(activeRow, row)) {
      activeRow.checkOut = row.checkOut
      return
    }

    rows.push(row)
    activeRow = row
  })

  return rows
}

export const quotationIdsEqual = (left?: unknown, right?: unknown) =>
  String(left ?? "").trim().toLowerCase() === String(right ?? "").trim().toLowerCase()

export const findQuotationVersionById = (
  versions: QuotationVersionItemModel[],
  quotationId: unknown,
): QuotationVersionItemModel | undefined =>
  versions.find((version) => quotationIdsEqual(version?.quotation_id, quotationId))

type PreviewQuotationLike = {
  quotation_id?: string
  quotation_status?: number
  quotation_status_name?: string
  quotation_status_id?: number
  version_no?: number
  created_at: string;
  created_by: string;
  [key: string]: unknown
}

export const resolveQuotationPreviewCurrentVersion = (
  versions: QuotationVersionItemModel[],
  urlQuotationId: string,
  quotation?: PreviewQuotationLike | null,
): QuotationVersionItemModel | undefined => {
  const canonicalId = String(quotation?.quotation_id || urlQuotationId || "").trim()
  const matched =
    findQuotationVersionById(versions, canonicalId) ||
    findQuotationVersionById(versions, urlQuotationId)
  if (matched) return matched

  const fallbackId = canonicalId || String(urlQuotationId || "").trim()
  if (!fallbackId || !quotation) return undefined

  return {
    quotation_id: fallbackId,
    version_no: Number(quotation.version_no || 1) || 1,
    quotation_status: quotation.quotation_status,
    quotation_status_name: quotation.quotation_status_name ?? "",
    quotation_status_id: quotation.quotation_status_id ?? 0,
    created_at: quotation.created_at,
    created_by: quotation.created_by
  }
}
